import { atom, selector, selectorFamily } from 'recoil';
import { Offer, OfferContent, OfferMedia } from '~/common/models';

export const ActiveSpecialOffer = atom<Offer | null>({
  key: 'ActiveSpecialOffer',
  default: null,
});

export const OfferMediaContent = selector<OfferMedia[]>({
  key: 'OfferMediaContent',
  get: ({ get }) => {
    return get(ActiveSpecialOffer)?.media ?? [];
  },
});

export const OfferContentFeatures = selector<OfferContent[]>({
  key: 'OfferContentFeatures',
  get: ({ get }) => {
    return (get(ActiveSpecialOffer)?.contents ?? [])
      .filter((o) => o.contentType === 'PARAGRAPH' || o.contentType === 'LIST')
      .sort((a, b) => a.displayOrder - b.displayOrder);
  },
});

export const OfferContentDisclaimers = selector<OfferContent[]>({
  key: 'OfferContentDisclaimers',
  get: ({ get }) => {
    return (get(ActiveSpecialOffer)?.contents ?? [])
      .filter((o) => o.contentType === 'DISCLAIMER-CONTENT')
      .sort((a, b) => a.displayOrder - b.displayOrder);
  },
});

export const OfferContentTitleDisclaimer = selector<OfferContent | undefined>({
  key: 'OfferContentTitleDisclaimer',
  get: ({ get }) => {
    return get(ActiveSpecialOffer)?.contents?.find(
      (o) => o.contentType === 'DISCLAIMER-CONTENT-TITLE'
    );
  },
});

export const OfferContentCTA = selectorFamily<
  OfferContent[],
  'floating-ctas' | 'bluebox-ctas' | 'sub-floating-ctas' | 'sub-bluebox-ctas'
>({
  key: 'OfferContentCTA',
  get:
    (section) =>
    ({ get }) => {
      const ctas: OfferContent[] = [];
      const offer = get(ActiveSpecialOffer);

      if (section === 'floating-ctas' || section === 'bluebox-ctas') {
        ctas.push({
          displayOrder: 0,
          contentType: 'CTA',
          content: {
            text: 'Enquire now',
            link: `${offer?.uniqueName}/enquire`,
            sections: ['floating-ctas', 'bluebox-ctas'],
            type: 'primary',
          },
        });
      }

      ctas.push(
        ...(offer?.contents ?? [])
          .filter(
            (o) =>
              o.contentType === 'CTA' && o.content.sections.includes(section)
          )
          .sort((a, b) => a.displayOrder - b.displayOrder)
      );

      return ctas;
    },
});
